import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  Icon,
  IconColor,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { MiniTitle } from '@delmonicos/shared-design-system-react/src/components/typography/mini-title/mini-title';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useEmspBoEmspUserContext } from '../emsp-bo-emsp-user.context';

export const EmspBoEmspUserPreferenceListController = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { preferences } = useEmspBoEmspUserContext();

  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Card direction="column" gap={GapEnum.L}>
      <Stack alignItems="center" gap={GapEnum.XS}>
        <AccentTitle
          icon="settings-01"
          text={t('delmonicos-shared-sdk.outputs-emsp-user.preferences')}
        />
      </Stack>
      <Stack direction="column" gap={GapEnum.M}>
        <Stack direction="column" gap={GapEnum.XS}>
          <MiniTitle>
            {t(
              'delmonicos-shared-sdk.outputs-emsp-user-preferences.display-language',
            )}
          </MiniTitle>
          <Text>{preferences.displayLanguage ?? '-'}</Text>
        </Stack>
        <Stack direction="column" gap={GapEnum.XS}>
          <MiniTitle>
            {t(
              'delmonicos-shared-sdk.outputs-emsp-user-preferences.auto-send-payment-ticket-by-mail',
            )}
          </MiniTitle>
          {preferences.autoSendPaymentTicketByMail ? (
            <Icon name="check-circle" color={IconColor.Success} />
          ) : (
            <Icon name="x-circle" color={IconColor.Error} />
          )}
        </Stack>
        <Stack direction="column" gap={GapEnum.XS}>
          <MiniTitle>
            {t(
              'delmonicos-shared-sdk.outputs-emsp-user-preferences.auto-send-invoice-by-mail',
            )}
          </MiniTitle>
          {preferences.autoSendInvoiceByMail ? (
            <Icon name="check-circle" color={IconColor.Success} />
          ) : (
            <Icon name="x-circle" color={IconColor.Error} />
          )}
        </Stack>
        <Stack direction="column" gap={GapEnum.XS}>
          <MiniTitle>
            {t(
              'delmonicos-shared-sdk.outputs-emsp-user-preferences.auto-send-charge-end-by-mail',
            )}
          </MiniTitle>
          {preferences.autoSendChargeEndByMail ? (
            <Icon name="check-circle" color={IconColor.Success} />
          ) : (
            <Icon name="x-circle" color={IconColor.Error} />
          )}
        </Stack>
        <Stack direction="column" gap={GapEnum.XS}>
          <MiniTitle>
            {t(
              'delmonicos-shared-sdk.outputs-emsp-user-preferences.enable-pseudo-check',
            )}
          </MiniTitle>
          {preferences.enablePseudoCheck ? (
            <Icon name="check-circle" color={IconColor.Success} />
          ) : (
            <Icon name="x-circle" color={IconColor.Error} />
          )}
        </Stack>
      </Stack>
    </Card>
  );
};
